var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentFeature)?_c('ClientOnly',[_c('article',{staticClass:"feature-card"},[_c('span',{staticClass:"feature-card__gradient"}),_vm._v(" "),_c(_vm.currentFeature,{tag:"Component"})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }